import { useContext, useMemo } from 'react'

import { GlobalContext } from '../../../Providers/GlobalProvider'
import EntitiesSelector from './EntitiesSelector'

const SectionsSelector = ({ disabled, empty = false, highlightValues = [], multiple, style = {}, sections = [], values, placeholder, onChange }) => {
  const gb = useContext(GlobalContext)

  const localSections = useMemo(() => sections ?? gb?.sections, [gb?.sections, sections])

  const sectionOptions = useMemo(() => localSections.map(section => ({
    label: section.abbreviation,
    value: section.id,
    tooltip: section.name,
    entity: section
  })), [localSections])
  const toBeHighlighted = useMemo(() => highlightValues.map(s => s.id), [highlightValues])

  return (
    <EntitiesSelector
      placeholder={placeholder}
      disabled={disabled}
      entityOptions={sectionOptions}
      highlightValues={toBeHighlighted}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default SectionsSelector
